import { httpClient } from '../http/httpClient'
import { JourneyDetails } from './types'

export async function getJourneyById(journeyId: string) {
  const { data } = await httpClient
    .get<JourneyDetails>(`/journeys/${journeyId}`)
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
